import { MULTISIG_FEATURE_FLAGS as MULTISIG_FEATURE_FLAGS_ENV } from "@/constants/envVariables";

// Append only. Never reorder or reuse bits — retired features leave a
// gap so historical bitmask values keep meaning what they used to.
export const MULTISIG_FEATURE_FLAGS = {
  WALLET_CONNECT: 1 << 0, // 1
  ENROLLMENT: 1 << 1, // 2
  SIGNER_MANAGEMENT: 1 << 2, // 4
  DISBURSEMENT_SIGNING: 1 << 3, // 8
  OPT_OUT: 1 << 4, // 16
  NOTIFICATIONS: 1 << 5, // 32
  STATUS_DASHBOARD: 1 << 6, // 64
} as const;

export type MultisigFeatureFlag =
  (typeof MULTISIG_FEATURE_FLAGS)[keyof typeof MULTISIG_FEATURE_FLAGS];

export const ENABLED_MULTISIG_FEATURES: number = MULTISIG_FEATURE_FLAGS_ENV;

export const isMultisigFeatureEnabled = (flag: MultisigFeatureFlag): boolean => {
  return (ENABLED_MULTISIG_FEATURES & flag) === flag;
};
